module.exports = __webpack_public_path__ + "static/media/chart-2.98f4af66.png";